import {Component, Input} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";

@Component({
  selector: 'app-door-rate',
  templateUrl: './door-rate.component.html',
  styleUrl: './door-rate.component.scss'
})
export class DoorRateComponent {
  @Input() claimDto: ClaimDto | null = null;

  constructor(
  ) {}

}
